import { createFileRoute } from '@tanstack/react-router'

import { Cases } from '@/widgets/case-management/cases'

export const Route = createFileRoute('/_app/case-management/cases/')({
  component: RouteComponent,
})

export const CaseManagementCasesRoute = Route

function RouteComponent() {
  return <Cases />
}
